import { useTranslation } from 'react-i18next'

import { AcknowledgeModal, Modal } from '@percent/lemonade'

type MoveToDraftOpportunitySuccessModalProps = {
  open: boolean
  handleClose: VoidFunction
}

export function MoveToDraftOpportunitySuccessModal({
  open,
  handleClose
}: Readonly<MoveToDraftOpportunitySuccessModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="move-to-draft-opportunity-success"
      data-testid="move-to-draft-opportunity-success-modal"
    >
      <AcknowledgeModal
        result="positive"
        title={t('dialog.volunteering.moveToDraft.success.title')}
        buttonText={t('button.close')}
        handleClose={handleClose}
        buttonTestId="move-to-draft-success-modal-btn"
      >
        {t('dialog.volunteering.moveToDraft.success.description')}
      </AcknowledgeModal>
    </Modal>
  )
}
